<template>
  <div class="pt-24 pb-20 md:pb-16 bg-white p-8 background--alt">
    <div class="container mx-auto text-left opacity-100 text-sm lg:px-4">
      <div
        class="flex flex-col justify-center items-start content-start lg:flex-row mb-4"
      >
        <!-- Company Information -->
        <p
          class="mt-32 text-left gt-walsheim-regular text-grey text-sm opacity-50 hidden lg:block"
        >
          © Pixoby
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>
